import { render, staticRenderFns } from "./CareerbookVersionModal.vue?vue&type=template&id=b14d37a4&"
import script from "./CareerbookVersionModal.vue?vue&type=script&lang=js&"
export * from "./CareerbookVersionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports